export default __webpack_public_path__ + "static/media/Belt of the Wells of Night.a5426e1f.jpg";